import { createContext, useContext } from 'react';

const EventWebinarContext = createContext({
  attendee: '',
  eventWebinarDetailGuid: '',
  registrationButtonUrl: '',
  isLoggedIn: false,
  title: '',
  description: '',
  disclaimer: '',
  eventDescription: '',
  showArchivedWebinar: false,
  programLevel: '',
  delivery: '',
  prerequisites: '',
  advancedPrep: '',
  cpeCount: '',
  cpeCreditNotes: '',
  cpeInformation: '',
  recordingUrl: '',
  accordionContent: '',
  contactName: '',
  contactEmail: '',
  eventType: '',
  primaryCategory: '',
  webinarKey: '',
  marketoProgramId: 0,
  dateFrom: new Date(Date.now()),
  dateTo: new Date(Date.now()),
  timeZone: '',
  venue: '',
  street: '',
  street2: '',
  city: '',
  state: '',
  postalCode: '',
  hideSocialShare: false,
  disableRegistrationButton: false,
  presenters: [],
  eventModerators: [],
  technicalSupportPhone: '',
  bdoEmployeesPhone: '',
  relatedEvents: [],
  isUserAuthorized: false,
  question1: '',
  question2: '',
  question3: '',
  recaptchaSiteKey: '',
  isAllianceClient: false
});

EventWebinarContext.displayName = 'EventWebinarContext';

export const withEventWebinarContext =
  (Component) =>
  ({
    attendee,
    eventWebinarDetailGuid,
    registrationButtonUrl,
    isLoggedIn,
    isRegistered,
    title,
    description,
    disclaimer,
    eventDescription,
    showArchivedWebinar,
    programLevel,
    delivery,
    prerequisites,
    advancedPrep,
    cpeCount,
    cpeCreditNotes,
    cpeInformation,
    recordingUrl,
    accordionContent,
    contactName,
    contactEmail,
    eventType,
    primaryCategory,
    webinarKey,
    marketoProgramId,
    dateFrom,
    dateTo,
    timeZone,
    tzDatabaseIdentifier,
    venue,
    street,
    street2,
    city,
    state,
    postalCode,
    hideSocialShare,
    disableRegistrationButton,
    presenters,
    eventModerators,
    technicalSupportPhone,
    bdoEmployeesPhone,
    relatedEvents,
    isUserAuthorized,
    question1,
    question2,
    question3,
    recaptchaSiteKey,
    isAllianceClient,
    baseUrl,
    ...passThroughProps
  }) =>
    (
      <EventWebinarContext.Provider
        value={{
          attendee,
          eventWebinarDetailGuid,
          registrationButtonUrl,
          isLoggedIn,
          isRegistered,
          title,
          description,
          disclaimer,
          eventDescription,
          showArchivedWebinar,
          programLevel,
          delivery,
          prerequisites,
          advancedPrep,
          cpeCount,
          cpeCreditNotes,
          cpeInformation,
          recordingUrl,
          accordionContent,
          contactName,
          contactEmail,
          eventType,
          primaryCategory,
          webinarKey,
          marketoProgramId,
          dateFrom,
          dateTo,
          timeZone,
          tzDatabaseIdentifier,
          venue,
          street,
          street2,
          city,
          state,
          postalCode,
          hideSocialShare,
          disableRegistrationButton,
          presenters,
          eventModerators,
          technicalSupportPhone,
          bdoEmployeesPhone,
          relatedEvents,
          isUserAuthorized,
          question1,
          question2,
          question3,
          isAllianceClient,
          recaptchaSiteKey,
          baseUrl
        }}
      >
        <Component {...passThroughProps} />
      </EventWebinarContext.Provider>
    );

export const useEventWebinarContext = () => useContext(EventWebinarContext);
